import styled from 'styled-components'

export const Section = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  border: 0.91px solid #e2e2e2;

  h2 {
    font-size: 1.6rem !important;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0;
  }

  .section-subtitle {
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
    margin-top: 4px;
  }
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px 20px;
  border-radius: 16px;
  border: 0.91px solid #e2e2e2;

  .invoice-info {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .invoice-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .invoice-month {
    font-size: 1.4rem !important;
    font-weight: 700;
    color: #2c2c2c;
    text-transform: capitalize;
  }

  .invoice-subtitle {
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }

  .invoice-actions {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }
`

export const IconSquare = styled.div<{ available: boolean }>`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ available }) => (available ? '#fff1e0' : '#f0f0f0')};

  svg {
    font-size: 2.2rem;
    color: ${({ available }) => (available ? '#ff5100' : '#8c8c8c')};
  }
`

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1.2rem !important;
  font-weight: 600;
  color: ${({ color }) => color};
  white-space: nowrap;
`

export const Dot = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #ff5100;
  background: transparent;
  color: #ff5100;
  font-size: 1.3rem !important;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover:not(:disabled) {
    background: #fff1e0;
  }

  &:disabled {
    border-color: #c2c2c2;
    color: #8c8c8c;
    cursor: not-allowed;
  }
`

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
  font-size: 1.4rem !important;
  color: ${({ theme }) => theme.colors.gray80};
`
